export default __webpack_public_path__ + "a05c82928af61dd68f5b01e9c1268715.png";